import React from 'react';
import styles from './CheckboxGroup.module.css';

type Option = {
    label: string;
    value: string | number;
};

type CheckboxGroupProps = {
    options: Option[];
    selectedValues: (string | number)[];
    onChange: (selected: (string | number)[]) => void;
};

const CheckboxGroup: React.FC<CheckboxGroupProps> = ({
    options,
    selectedValues,
    onChange,
}) => {
    const handleCheckboxChange = (value: string | number) => {
        const isSelected = selectedValues.includes(value);
        const updatedValues = isSelected
            ? selectedValues.filter((v) => v !== value)
            : [...selectedValues, value];
        onChange(updatedValues);
    };

    return (
        <div className={styles.checkboxGroup}>
            {options.map((option) => (
                <label key={option.value} className={styles.checkboxItem}>
                    <input
                        type="checkbox"
                        checked={selectedValues.includes(option.value)}
                        onChange={() => handleCheckboxChange(option.value)}
                        className={styles.checkboxInput}
                    />
                    <span>{option.label}</span>
                </label>
            ))}
        </div>
    );
};

export default CheckboxGroup;